var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isModal)?_c('h1',[_vm._t("default")],2):_c('h2',{staticClass:"text-center lg:text-2xl text-lg pr-0"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }